import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { selectFrame } from '../../actions/project/frame'
import PreviewProduct from './../../components/PreviewProduct'
import { startCropping } from '../../actions/project/crop'
import { toggleFramesModal } from "../../actions/sidebar";

const mapStateToProps = state => ({
  perMeter: dotProp.get(state, 'project.background.perMeter', 1000),
  selected: dotProp.get(state, 'project.selected', []),
  isSelected:
    dotProp.get(state, 'project.selectedObject', '') !== 'frame' ? -1 : dotProp.get(state, 'project.selectedIndex', -1),
})

const mapDispatchToProps = dispatch => ({
  onSelect: index => dispatch(selectFrame(index)),
  cropImage: () => dispatch(startCropping()),
  onZoom: src => dispatch(toggleFramesModal(src)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewProduct)



// WEBPACK FOOTER //
// ./src/containers/PreviewProduct/index.js